export default {
    GET_NEXT_CONSULTATION_SCHEDULE_REQUEST: 'GET_NEXT_CONSULTATION_SCHEDULE_REQUEST',
    GET_NEXT_CONSULTATION_SCHEDULE_SUCCESS: 'GET_NEXT_CONSULTATION_SCHEDULE_SUCCESS',
    GET_NEXT_CONSULTATION_SCHEDULE_FAILURE: 'GET_NEXT_CONSULTATION_SCHEDULE_FAILURE',

    GET_ADDITIONAL_RECOMMENDED_TEST_REQUEST: 'GET_ADDITIONAL_RECOMMENDED_TEST_REQUEST',
    GET_ADDITIONAL_RECOMMENDED_TEST_SUCCESS: 'GET_ADDITIONAL_RECOMMENDED_TEST_SUCCESS',
    GET_ADDITIONAL_RECOMMENDED_TEST_FAILURE: 'GET_ADDITIONAL_RECOMMENDED_TEST_FAILURE',

    GET_FOLLOW_UP_TEST_REQUEST: 'GET_FOLLOW_UP_TEST_REQUEST',
    GET_FOLLOW_UP_TEST_SUCCESS: 'GET_FOLLOW_UP_TEST_SUCCESS',
    GET_FOLLOW_UP_TEST_FAILURE: 'GET_FOLLOW_UP_TEST_FAILURE',

    GET_CONSULTATION_OBSERVATION_REQUEST: 'GET_CONSULTATION_OBSERVATION_REQUEST',
    GET_CONSULTATION_OBSERVATION_SUCCESS: 'GET_CONSULTATION_OBSERVATION_SUCCESS',
    GET_CONSULTATION_OBSERVATION_FAILURE: 'GET_CONSULTATION_OBSERVATION_FAILURE',

    CREATE_CONSULTATION_REQUEST: 'CREATE_CONSULTATION_REQUEST',
    CREATE_CONSULTATION_SUCCESS: 'CREATE_CONSULTATION_SUCCESS',
    CREATE_CONSULTATION_FAILURE: 'CREATE_CONSULTATION_FAILURE',

    RESET_CONSULTATION_STATE:'RESET_CONSULTATION_STATE',

    UPDATE_CONSULTATION_REQUEST: 'UPDATE_CONSULTATION_REQUEST',
    UPDATE_CONSULTATION_SUCCESS: 'UPDATE_CONSULTATION_SUCCESS',
    UPDATE_CONSULTATION_FAILURE: 'UPDATE_CONSULTATION_FAILURE',

    GET_TREATMENT_REQUEST: 'GET_TREATMENT_REQUEST',
    GET_TREATMENT_SUCCESS: 'GET_TREATMENT_SUCCESS',
    GET_TREATMENT_FAILURE: 'GET_TREATMENT_FAILURE',

    CREATE_UPDATE_TREATMENT_REQUEST: 'CREATE_UPDATE_TREATMENT_REQUEST',
    CREATE_UPDATE_TREATMENT_SUCCESS: 'CREATE_UPDATE_TREATMENT_SUCCESS',
    CREATE_UPDATE_TREATMENT_FAILURE: 'CREATE_UPDATE_TREATMENT_FAILURE',

    RESET_TREATMENT_CREATION_STATE:' RESET_TREATMENT_CREATION_STATE',

    END_CONSULTATION_REQUEST: 'END_CONSULTATION_REQUEST',
    END_CONSULTATION_SUCCESS: 'END_CONSULTATION_SUCCESS',
    END_CONSULTATION_FAILURE: 'END_CONSULTATION_FAILURE',

    UPDATE_PHYSICAL_DATA_REQUEST: 'UPDATE_PHYSICAL_DATA_REQUEST',
    UPDATE_PHYSICAL_DATA_SUCCESS: 'UPDATE_PHYSICAL_DATA_SUCCESS',
    UPDATE_PHYSICAL_DATA_FAILURE: 'UPDATE_PHYSICAL_DATA_FAILURE',
};
